import { render, staticRenderFns } from "./DataViewerRow.vue?vue&type=template&id=60f2411e&"
import script from "./DataViewerRow.vue?vue&type=script&lang=js&"
export * from "./DataViewerRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports